module.exports = __webpack_public_path__ + "img/_2.8eff87ab.png";